<template>
  <div class="block">
    <el-timeline style="margin-top: 20px">
      <el-timeline-item
        v-for="(activity, index) in activities"
        :key="index"
        :icon="activity.icon"
        :type="activity.type"
        :color="activity.color"
        :size="activity.size"
        :timestamp="activity.timestamp"
      >
        {{ activity.content }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
import { formatDateByElementFormat } from '@/utils/date';

export default {
  props: {
    name: String,
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dateTimeFormat() {
      return this.$store.getters.dateTimeFormat;
    },
    activities() {
      let first = true;
      return this.value.map(log => {
        log.first = first;
        first = false;
        const status = this.formatStatusOption(log.orderLineStatusOption);
        return {
          content: `${status} - ${log.orderLineSubstatusName}`,
          size: 'large',
          timestamp: this.formatTimestamp(log),
          type: log.first ? 'primary' : undefined
        };
      });
    }
  },
  methods: {
    formatStatusOption(value) {
      const option =
        value !== null &&
        this.$store.getters['option/loadedOptions']('orderLineStatus').find(item => item.code === value);
      return option && option.description;
    },
    formatTimestamp(log) {
      const timestamp = formatDateByElementFormat(log.occurredAt, this.dateTimeFormat);
      if (log.seriesNumber) {
        return `${timestamp}, ${log.seriesNumber}`;
      }
      return timestamp;
    }
  }
};
</script>

<style lang="scss">
.el-timeline-item {
  padding-bottom: 10px;
}
</style>
